export const validateRelianceIPAHelper = (value, field, formik) => {
  const { name, arrayIndex } = field;
  const { values: formikValues } = formik;

  const Relationship = {
    Self: "345",
    Spouse: "320",
    Dependent_Daughter: "1989",
    Dependent_Son: "1988",
  };

  /**
   *  Sum Insured of Non Earning Spouse is Restricted to Table C
   *  Sum Insured of Child is Restricted to Table B
   */
  if (name === `primaryDetails[${arrayIndex}].TableOfBenifits`) {
    const primaryDetails = formikValues?.primaryDetails;
    const currentDetail = primaryDetails?.[arrayIndex];

    if (!currentDetail) return null;

    const relationship = currentDetail.RelationshipWithProposerID;
    const tableOfBenefits = value;

    if (
      relationship === Relationship.Spouse &&
      currentDetail.IsEarningMember === "false" &&
      tableOfBenefits !== "IsTableC"
    ) {
      return "Sum Insured of Non Earning Spouse is Restricted to Table C";
    }

    if (
      (relationship === Relationship.Dependent_Daughter ||
        relationship === Relationship.Dependent_Son) &&
      tableOfBenefits !== "IsTableB"
    ) {
      return "Sum Insured of Child is Restricted to Table B";
    }
  }

  return null;
};
